import request from 'src/shared/utils/requester';

const USE_CASE_URL = 'inventory';

const updateInventoryById = async (body, inventoryId) => {
  const method = 'PUT';
  const url = `${USE_CASE_URL}/${inventoryId}`;

  const json = await request({ method, url, body });
  return json;
};

export default updateInventoryById;
